import React from "react";
import { Redirect } from "react-router-dom";
import sessionsRoutes from "./views/sessions/sessionsRoutes";
import AuthGuard from "./auth/AuthGuard";
import AppRoutes from "./_pages/AppRoutes";
import UserManagementRoutes from "./_pages/UserManagement/UserManagementRoutes";
import GlobalSettingsRoutes from "./_pages/_globalConfiguration/GlobalSettingsRoutes";
import HealthSafetyEnvironmentRoutes from "./_pages/_healthSafetyEnvironment/HealthSafetyEnvironmentRoutes";
import SitesRoutes from "./_pages/Sites/SitesRoutes";

const redirectRoute = [
  {
    path: "/",
    exact: true,
    nav: 1,
    component: () => <Redirect to="/session/signin" />,
  },
];

const errorRoute = [
  {
    component: () => <Redirect to="/session/404" />,
  },
];

const routes = [
  ...sessionsRoutes,
  {
    path: "/",
    component: AuthGuard,
    routes: [
      ...UserManagementRoutes,
      ...AppRoutes,
      ...GlobalSettingsRoutes,
      ...SitesRoutes,
      ...HealthSafetyEnvironmentRoutes,
      ...redirectRoute,
      ...errorRoute,
    ],
  },
];

export default routes;
